import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Field, formValueSelector, change } from 'redux-form'

import WrappedInput from '../../Shared/Forms/WrappedInput'
import FileInput from '../../Shared/Forms/FileInput'

export default function Firestore({ form }) {
  const dispatch = useDispatch()
  const mounted = useRef(false)

  const selector = formValueSelector(form)

  const key = useSelector(state => selector(state, 'serviceAccountKey'))

  useEffect(() => {
    const projectId = key && key.data && key.data.project_id

    if (mounted.current && projectId) {
      dispatch(
        change(form, 'databaseURL', `https://${projectId}.firebaseio.com`)
      )

      const name = projectId.match(/-\d+$/)
        ? projectId.split('-').slice(0, -1).join('-')
        : projectId

      dispatch(change(form, 'name', name))
    }

    mounted.current = true
  }, [dispatch, key])

  return (
    <>
      <Field
        jsonValue
        component={FileInput}
        name="serviceAccountKey"
        label="Service Account Key"
        helpText={
          <a
            href="https://docs.easybutton.io/firebase-cloud-firestore-setup"
            target="_blank"
            rel="noreferrer"
          >
            How do I generate this?
          </a>
        }
      />
      <Field
        name="databaseURL"
        component={WrappedInput}
        label="Database URL"
        placeholder="https://my-app.firebaseio.com"
      />
      <Field
        component={WrappedInput}
        name="name"
        label="Nickname"
        placeholder="My New Database"
        autoComplete="off"
      />
    </>
  )
}
